import React, { useState, useContext } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import {
  CodeFullDetailDescription,
  ConfirmValidMessage,
  ReturnError,
  ShowSpinner,
  Modal,
  ModalButtonGroup,
} from '../commons';
import { modalBlurbs } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { clickCta } from '../../../../../utils/analytics';

export const UnenrollModals = (): JSX.Element => {
  const {
    setIsLoading,
    setShowModal,
    setErrorState,
    currentAgreementCode,
    enrollAgreementCode,
  } = useContext<any>(NationalAccountContext);
  const [isFinalConfirm, setFinalConfirm] = useState(false);

  const handleUnenrollSubmit = async () => {
    setIsLoading(true);
    const response = await enrollAgreementCode(
      false,
      currentAgreementCode?.abbreviatedName,
      '',
    );

    setIsLoading(false);
    if (response && !response.error) {
      setShowModal(true);
      setFinalConfirm(true);
      clickCta('pricing benefits: national account incentives: unenrolled');
    } else {
      setErrorState(true);
    }
  };

  return (
    <Modal title={modalBlurbs.unenroll.title.unenrollIncentives}>
      {isFinalConfirm ? (
        <FinalConfirmModal />
      ) : (
        <VerifyUnenrollModal handleUnenrollSubmit={handleUnenrollSubmit} />
      )}
    </Modal>
  );
};

const FinalConfirmModal = (): JSX.Element => {
  const { setShowModal } = useContext<any>(NationalAccountContext);
  return (
    <div
      className="sui-flex sui-flex-col sui-justify-center sui-align-start"
      data-testid="FinalConfirmModal"
    >
      <div className="sui-flex sui-flex-col sui-justify-center sui-align-start sui-pb-4">
        <ConfirmValidMessage
          confirmMessage={modalBlurbs.unenroll.unenrollConfirmation}
          doJustifyStart
        />
        <p className="sui-text-base">
          {modalBlurbs.unenroll.unenrollConfirmationDisclaimer}
        </p>
      </div>
      <div className="sui-flex sui-flex-row sui-justify-center sui-align-center">
        <Button
          variant="primary"
          type="submit"
          disabled={false}
          style={{ width: '100%' }}
          onClick={() => {
            setShowModal(false);
            window.location.reload();
          }}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

const VerifyUnenrollModal = ({ handleUnenrollSubmit }: any): JSX.Element => {
  const { setErrorState, errorState, setShowModal, isLoading } =
    useContext<any>(NationalAccountContext);

  const cancelModal = () => {
    setShowModal(false);
    setErrorState(false);
  };
  return (
    <div
      className="sui-flex sui-flex-col sui-justify-center sui-font-regular sui-text-1xl"
      data-testid="VerifyUnenrollModal"
    >
      <p className="sui-text-base sui-pt-4">
        {modalBlurbs.unenroll.unenrollDoubleCheck}
      </p>
      <div className="sui-pt-4">
        {errorState ? <ReturnError /> : <CodeFullDetailDescription isModal />}
      </div>
      {isLoading && <ShowSpinner />}
      <ModalButtonGroup
        handleClose={cancelModal}
        confirmBlurb={modalBlurbs.unenroll.buttons.unEnrollConfirm}
        cancelBlurb={modalBlurbs.unenroll.buttons.unEnrollCancel}
        cb={handleUnenrollSubmit}
      />
    </div>
  );
};
